import { DestinationsMenuTopDestination } from '../../../../resources/destinationsMenu/domain/types/destinationsMenu';

import { FooterLinksAbout } from './FooterLinksAbout/FooterLinksAbout';
import { FooterLinksCommunication } from './FooterLinksCommunication/FooterLinksCommunication';
import { FooterLinksContact } from './FooterLinksContact/FooterLinksContact';
import { FooterLinksCountries } from './FooterLinksCountries/FooterLinksCountries';
import { FooterLinksTopDestinations } from './FooterLinksTopDestinations/FooterLinksTopDestinations';

import style from './FooterLinks.module.css';

type Props = {
    topDestinations: Array<DestinationsMenuTopDestination>;
};

export function FooterLinks({ topDestinations }: Props) {
    return (
        <div className={style.wrapper}>
            <div className={style.item}>
                <FooterLinksCountries />
            </div>
            <div className={style.item}>
                <FooterLinksAbout />
            </div>
            <div className={style.item}>
                <div className={style.communicationContactColumn}>
                    <FooterLinksCommunication />
                    <FooterLinksContact />
                </div>
            </div>
            {topDestinations.length > 0 ? (
                <div className={style.item}>
                    <FooterLinksTopDestinations destinations={topDestinations} />
                </div>
            ) : null}
        </div>
    );
}
